import { useEffect, useState } from 'react';
import { getMediaCacheTotalCounts, getMediaCacheData } from 'api/ugc';
import useClientErrorHandler, { generateApiErrObj } from 'client/hooks/useClientErrorHandler';
import * as clientErrTypes from 'config/clientErrorTypes';

const useGetGalleryMediaList = promoUUID => {
    const [media, setMedia] = useState([]);
    const [isInit, setIsInit] = useState(false);
    const errHandler = useClientErrorHandler();
    useEffect(() => {
        const initFlow = async () => {
            try {
                const totalCountsResp = await getMediaCacheTotalCounts({ promoUUID });
                if (totalCountsResp.httpStatus !== 200) {
                    throw generateApiErrObj(totalCountsResp, clientErrTypes.UGC_GET_MEDIA_COUNTS);
                }
                const { payload } = await getMediaCacheData({
                    promoUUID: promoUUID,
                    firstNum: totalCountsResp?.payload?.first ?? 1,
                    defaultNum: totalCountsResp?.payload?.default ?? 20
                });
                const mediaDefault = payload[0]?.default ?? [];
                const mediaFirst = payload[0]?.first ?? [];
                // [#86epphvu7] 若客戶於活動後台將比較漂亮的作品，輪播牆顯示設定為優先顯示
                const allMedia = [...mediaFirst, ...mediaDefault];
                setMedia(allMedia);
                setIsInit(true);
            } catch (err) {
                console.error(err);
                errHandler({ err });
            }
        };
        if (promoUUID) {
            initFlow();
        }
    }, [errHandler, promoUUID]);
    return { galleryMediaList: media, isInit, setIsInit };
};

export default useGetGalleryMediaList;
